import { inject } from '@angular/core';

import { APP_STORE } from '@core/stores/app.store';

export const CLIENT_CAN_ACTIVATE_GUARD = (): boolean => hasClientId();

export const CLIENT_CAN_MATCH_GUARD = (): boolean => hasClientId();

const hasClientId = (): boolean => {
  const appStore = inject(APP_STORE);

  return !!appStore.selectedClientId();
};
